export const REQUEST_VOICES = 'cboard/Speech/REQUEST_VOICES';
export const RECEIVE_VOICES = 'cboard/Speech/RECEIVE_VOICES';
export const CHANGE_VOICE = 'cboard/Speech/CHANGE_VOICE';
export const CHANGE_PITCH = 'cboard/Speech/CHANGE_PITCH';
export const CHANGE_RATE = 'cboard/Speech/CHANGE_RATE';
export const CHANGE_VOLUME = 'cboard/Speech/CHANGE_VOLUME';
export const START_SPEECH = 'cboard/Speech/START_SPEECH';
export const END_SPEECH = 'cboard/Speech/END_SPEECH';
export const CANCEL_SPEECH = 'cboard/Speech/CANCEL_SPEECH';
export const RECEIVE_TTS_ENGINES = 'cboard/Speech/RECEIVE_TTS_ENGINES';
export const RECEIVE_TTS_DEFAULT_ENGINE =
  'cboard/Speech/RECEIVE_TTS_DEFAULT_ENGINE';
export const REQUEST_TTS_ENGINE = 'cboard/Speech/REQUEST_TTS_ENGINE';
export const RECEIVE_TTS_ENGINE = 'cboard/Speech/RECEIVE_TTS_ENGINE';
export const EMPTY_VOICES = 'empty voices';
